import { auth as client } from '@/apis/client'
import { LoginRequest, LoginResponse } from '@/types/authTypes'

export const login = (req: LoginRequest) => {
  return client.post<LoginResponse>('/login', req)
}

export const logout = () => {
  return client.post<void>('/logout')
}
